/* global register_user_ajax_url, translationsEmail */
export default {
  init() {
    checkEmail();
  },
  finalize() {
    // JavaScript to be fired on the checkout page, after the init JS
  },
};

export var checkEmail = () => {
  $('button[name="register"]').on('click', function(e) {
    let email = $('#email').val();
    e.preventDefault();
    // eslint-disable-next-line no-useless-escape
    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (regex.test(email))
    {
      $.ajax({
        type: 'POST'
        , dataType: 'json'
        , url: register_user_ajax_url.ajax_url
        , data: {
          'email': email,
        }
        , success: function (response) {
          if(response.success) {
            //Redirect user if the email doesn't belong to a user in the CusteromDatabase
            let url = register_user_ajax_url.redirect_url;
            let redirectUrl = url.slice(0, -1) + '?email=' + email;
            window.location.replace(redirectUrl);
          }else {
            //message tonen
            $('<p class="error-message">' + response.data + '</p>').insertBefore($('.customer_register'));
          }
        },
      });
    }else{
      console.log(translationsEmail);
      $('<p class="error-message">' + translationsEmail.invalid_email + '</p>').insertBefore($('.customer_register'));
    }
  });
}
